import React, { useState, useEffect } from 'react';
import ApiServices from '../services/ApiServices';
import { ShowDangerToast } from '../services/toast';
const RecentActivities = ({ storeId }) => {
  const [activities, setActivities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const activitiesPerPage = 5;
  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const response = await ApiServices.getData(`/stores/recent-activities${storeId ? `?storeId=${storeId}` : ''}`);
        setActivities(response.data);
      } catch (error) {
        ShowDangerToast('Failed to load recent activities');
      }
    };
    fetchActivities();
  }, [storeId]);
  const totalPages = Math.ceil(activities.length / activitiesPerPage);
  const currentActivities = activities.slice((currentPage - 1) * activitiesPerPage, currentPage * activitiesPerPage);
  return (
    <div>
      <div className="space-y-3">
        {currentActivities.map((activity) => (
          <div
            key={activity.id}
            className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm border border-gray-100 text-gray-700"
          >
            <div>
              <p className="text-sm font-semibold text-navy-800">{activity.activity}</p>
              <p className="text-xs text-brand-orange">By: {activity.doneBy || 'Unknown'}</p>
            </div>
            <p className="text-xs text-gray-500">{new Date(activity.date).toLocaleString()}</p>
          </div>
        ))}
      </div>
      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(prev => prev - 1)}
          className="btn-primary text-sm px-4 py-1.5 disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-navy-800 text-sm">Page {currentPage} of {totalPages}</span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(prev => prev + 1)}
          className="btn-primary text-sm px-4 py-1.5 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};
export default RecentActivities;
